import React from "react";
import { cn } from "../../../lib/utils";
import { formatPrice } from "../../../lib/utils";

interface OptionPriceProps {
  price?: number;
  isSelected?: boolean;
  className?: string;
}

export const OptionPrice: React.FC<OptionPriceProps> = ({
  price,
  isSelected = false,
  className,
}) => {
  if (price === undefined) return null;

  return (
    <span
      className={cn(
        "text-lg",
        isSelected ? "text-white" : "text-black",
        className
      )}
      style={{ fontWeight: "300" }}
    >
      {formatPrice(price)}
    </span>
  );
};
